var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.isMobile ? "text-center" : "" },
    [
      _vm.isMobile
        ? _c("SelectCreditsDropdown", {
            attrs: {
              "selectable-credits": _vm.selectableCredits,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "labelText",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("trans")("Credits")) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass:
                          "fa fa-question-circle text-info cursor-pointer",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.learnMore = !_vm.learnMore
                          },
                        },
                      }),
                      _vm._v(":\n            "),
                      _c("br"),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              946731636
            ),
            model: {
              value: _vm.selectedCredits,
              callback: function ($$v) {
                _vm.selectedCredits = $$v
              },
              expression: "selectedCredits",
            },
          })
        : !_vm.isMobile
        ? _c("SelectCreditsSlider", {
            attrs: {
              "selectable-credits": _vm.selectableCredits,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u([
              {
                key: "labelText",
                fn: function () {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("trans")("Credits")) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa fa-question-circle text-info cursor-pointer",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.learnMore = !_vm.learnMore
                        },
                      },
                    }),
                    _vm._v(":\n        "),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedCredits,
              callback: function ($$v) {
                _vm.selectedCredits = $$v
              },
              expression: "selectedCredits",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade-grow" } }, [
        _vm.learnMore
          ? _c(
              "div",
              {
                staticClass:
                  "border px-4 py-3 mb-4 bg-white rounded position-relative mt-3",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.learnMore = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("trans")(
                          "Extend your Credits included in your subscription and continue to use certain premium tasks."
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }